var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.039,
    height: 30.695,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4c2f7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.02,
    cy: 26.349,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.02,
    cy: 26.349,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34 22.021a4 4 0 0 0-4 4h-.673a2 2 0 1 1 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.361 22.021a4 4 0 0 0-4 4H11.34a4 4 0 0 0-4-4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7facfa",
    d: "M27.356 22.021a4 4 0 0 0-4 4h2a4 4 0 0 1 4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.372 17.478v7.214a1.34 1.34 0 0 1-1.335 1.335h-4.671a4 4 0 0 0-4-4h-4.008V5.339h4v10.677a1.34 1.34 0 0 0 1.335 1.335h8.668c.007.042.011.084.011.127z",
    fill: "#e8edfc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.695 17.351h2a1.34 1.34 0 0 1-1.335-1.335V5.339h-2v10.677a1.34 1.34 0 0 0 1.335 1.335zm10.67-.001h-2a.81.81 0 0 1 .007.127v7.213a1.34 1.34 0 0 1-1.337 1.335h2a1.34 1.34 0 0 0 1.335-1.335v-7.213a.81.81 0 0 0-.005-.127z",
    fill: "#cad9fc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.362 17.351h-8.665a1.34 1.34 0 0 1-1.335-1.335V5.339h4.444c.541 0 1.029.326 1.235.827l4.031 9.783a3.9 3.9 0 0 1 .294 1.4z",
    fill: "#a4c2f7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.358 2.002v20.02H2.002a1.34 1.34 0 0 1-1.335-1.335V2.002A1.34 1.34 0 0 1 2.002.667h22.021a1.34 1.34 0 0 1 1.335 1.335z",
    fill: "#e8edfc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.021.667h-2a1.34 1.34 0 0 1 1.335 1.335v20.02h2V2.002A1.34 1.34 0 0 0 24.021.667z",
    fill: "#cad9fc"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e8edfc"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.52,
    cy: 25.849,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.52,
    cy: 25.849,
    r: 1.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.667 24.023a2 2 0 0 0 2 2h.667a3.99 3.99 0 0 0 5 3.87 4 4 0 0 1-3-3.87h-.667a2 2 0 1 1 0-4h-.663a1.34 1.34 0 0 1-1.337-1.336V2.002A1.34 1.34 0 0 1 4.004.667h-2A1.34 1.34 0 0 0 .667 2.002v18.685a1.34 1.34 0 0 0 1.335 1.335h.665a2 2 0 0 0-2 2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.348h1.335v5.339H0z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#428dff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.658 5.91a2 2 0 0 0-1.852-1.239h-7.781V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v13.348a.668.668 0 1 0 1.335 0V2A.667.667 0 0 1 2 1.335h22.023a.667.667 0 0 1 .668.665v19.354H2a.667.667 0 0 1-.667-.667.668.668 0 1 0-1.335 0 1.989 1.989 0 0 0 .721 1.525 2.664 2.664 0 0 0 1.949 4.48h.053a4.665 4.665 0 0 0 9.236 0h12.787a4.665 4.665 0 0 0 9.236 0h4.057a2 2 0 0 0 2-2v-7.217a4.657 4.657 0 0 0-.352-1.779zm-1.235.508l4.029 9.786a3.337 3.337 0 0 1 .145.478H30.7a.667.667 0 0 1-.667-.667V6.006h3.777a.667.667 0 0 1 .614.413zm-9.066 16.27h.743a4.658 4.658 0 0 0-1.355 2.669H11.958a4.658 4.658 0 0 0-1.358-2.668zM1.726 24.966a1.335 1.335 0 0 1 .943-2.278h1.408a4.658 4.658 0 0 0-1.355 2.669h-.053a1.323 1.323 0 0 1-.943-.392zm5.614 4.4a3.337 3.337 0 1 1 3.337-3.337 3.337 3.337 0 0 1-3.337 3.333zm22.021 0a3.337 3.337 0 1 1 3.339-3.341 3.337 3.337 0 0 1-3.338 3.337zm8.675-4H33.98a4.671 4.671 0 0 0-4.618-4h-3.337V6.006h2.669v10.01a2 2 0 0 0 2 2H38.7v1.335h-.667a.668.668 0 1 0 0 1.335h.667v1.335h-.667a.668.668 0 1 0 0 1.335h.667v1.335a.667.667 0 0 1-.663.667zM.681 18.685a.67.67 0 0 1-.671-.664.67.67 0 0 1 .664-.671h.007a.67.67 0 0 1 .668.667.67.67 0 0 1-.668.668zM5.338 4.004a.67.67 0 0 0 .668-.667.67.67 0 0 0-.668-.668h-2a.67.67 0 0 0-.667.668.67.67 0 0 0 .667.668zm17.35 0a.67.67 0 0 0 .668-.667.67.67 0 0 0-.668-.668H8.007a.67.67 0 0 0-.668.668.67.67 0 0 0 .668.668z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M29.36 24.023a2 2 0 1 0 0 4 2 2 0 1 0 0-4zm0 2.669c-.368-.001-.665-.3-.665-.668s.298-.666.666-.666.667.297.668.665c.001.178-.07.348-.195.474s-.296.196-.474.195z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.fd1a8e97df57e3ee3df3c635a0b4b504.svg";
export { ForwardRef as ReactComponent };